import React, { useState } from "react";
import { useDialogsContext } from "../../../contexts/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Close from "./Close";
import Next from "./Next";
import Back from "./Back";
import Journey from "./Journey";
import Stats from "./Stats";
import BottomLine from "./BottomLine";

const useStyles = makeStyles((theme) => ({
  content: {
    width: 590,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingRight: theme.spacing(6.25),
    paddingLeft: theme.spacing(6.25),
    color: theme.palette.grey[600],
  },
  pages: { width: "100%" },
}));

export default function PlanDiscoveryDialog({
  plan,
  userCompletedPlanDiscovery,
}) {
  const classes = useStyles();

  const dialog: any = useDialogsContext();

  const [activeStep, setActiveStep] = useState(1);

  function goForward() {
    setActiveStep(activeStep + 1);
  }

  function goBack() {
    setActiveStep(activeStep - 1);
  }

  const close = (expand = false) => {
    userCompletedPlanDiscovery(plan.id, expand);
    dialog.close("planDiscovery");
    setActiveStep(1);
  };

  const pages = [
    <Journey plan={plan} />,
    <Stats plan={plan} showLast={false} />,
    <Stats plan={plan} showFirst={false} />,
    <BottomLine plan={plan} ownPage={true} />,
  ];

  return (
    <Dialog open={dialog.planDiscovery}>
      <Close close={close} />
      <DialogContent className={classes.content}>
        <div className={classes.pages}> {pages[activeStep - 1]}</div>
        <Next
          goForward={goForward}
          activeStep={activeStep}
          numPages={pages.length}
          close={close}
        />
      </DialogContent>
      <Back activeStep={activeStep} goBack={goBack} />
    </Dialog>
  );
}
